import { createContext, useContext } from 'react';

export type ToastTone = 'success' | 'error' | 'info';

export const ToastContext = createContext<(message: string, tone?: ToastTone) => void>(
  () => undefined,
);

/** Shows a short message in the corner (rendered by `ToastProvider`). */
export function useToast() {
  return useContext(ToastContext);
}
